import React from "react";
import { Step } from "../Step";
import { translate } from "../../Translation";
import { appConfig } from "../../config";
import { ImWhatsapp, ImPhone } from "react-icons/im";
import { AiOutlineMail } from "react-icons/ai";
import MobileTitle from "./MobileTitle";
import { inject, observer } from "mobx-react";
import { AI } from "../Ai";
import { withRouter } from "react-router-dom";

@inject("AppStore")
@observer
class Header extends React.Component {
  store = this.props.AppStore;

  clientTools = {
    initialize: async () => {
      console.log("Initialize", this.store.data.name);
    },
    selectModel: async (model) => {
      console.log("Selected model:", model);
      this.props.history.push(`/${this.store.page.lang}/build/${model.slug}`);
    },
    selectOption: async (option) => {
      console.log("Selected option:", option);
      this.store.selectOptionAI(option.id);
    },
    selectOptionGroup: async (optionGroup) => {
      console.log("Selected option group:", optionGroup);
      // this.store.selectOptionGroupAI(optionGroup.id);
    },
    selectDependency: async (dependency) => {
      console.log("Selected dependency:", dependency);
      // this.store.selectDependencyAI(dependency.id);
    },
    closePopup: async () => {
      console.log("Closed popup");
      //this.store.closePopupAI();
    },
    selectStep: async (step) => {
      console.log("Selected step:", step);
      this.store.onStepSelectedAI(step.id);
    },
  };

  logout() {
    localStorage.removeItem("isLoggedIn");
    window.location.reload();
  }

  render() {
    const { page, data, location, user } = this.store;

    const isLoggedIn = localStorage.getItem("isLoggedIn");
    console.log(isLoggedIn);

    return (
      <>
        <div className="header">
          <div className="logo-wrapper">
            <a
              href={`/${page.lang}`}
              style={{
                display: "flex",
                alignItems: "center",
                color: "#000",
                textDecoration: "none",
                fontSize: 12,
                fontWeight: "bold",
              }}
            >
              <img
                src={appConfig.locale.api + this.store.configuration?.logo?.url}
                className="logo"
                alt=""
              />
            </a>
          </div>
          <div
            className="steps"
            style={page.hideSteps ? { display: "none" } : null}
          >
            {data.steps?.length > 1 && !this.store.page.completed && (
              <React.Fragment>
                {data.steps.map((step, i) => (
                  <Step
                    key={i}
                    id={step.id}
                    order={i + 1}
                    visited={i <= page.stepIndex}
                    selected={i === page.stepIndex}
                    onSelected={() => {
                      this.store.onStepSelected(step, i);
                    }}
                    title={this.store.translate(step.title_t)}
                    color={this.store.data.color}
                  />
                ))}
                <Step
                  id={-1}
                  order={page.summaryStep}
                  visited={page.summaryStep <= page.stepIndex}
                  selected={page.summaryStep <= page.stepIndex}
                  onSelected={() => {
                    this.store.onStepSelected({}, page.summaryStep);
                  }}
                  title={translate("SUMMARY", this.store.page.lang)}
                />
              </React.Fragment>
            )}
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-around",
              gap: 12,
              marginRight: 24,
            }}
          >
            {appConfig.locale.aiEnabled && (
              <AI
                clientTools={this.clientTools}
                model={this.store.data.name}
                onConnected={(conversation) => {
                  this.store.setConversation(conversation);
                  this.store.sendModelUpdate();
                }}
                onDisconnected={() => {
                  this.store.setConversationDisconnected();
                }}
              />
            )}
          </div>

          {user ? (
            <div
              className="header-user-inner"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                paddingRight: 10,
                fontSize: 13,
              }}
            >
              <span>{user.user.fullname} -&nbsp;</span>
              <a onClick={this.store.logout} style={{ color: "#000" }}>
                LOGOUT
              </a>
            </div>
          ) : (
            <React.Fragment>
              <div
                className="social"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-around",
                  gap: 12,
                  marginRight: 24,
                }}
              >
                <div>
                  <a
                    href={`https://api.whatsapp.com/send?phone=${
                      location && location.phone_whatsapp
                    }`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <ImWhatsapp color={data.color} fontSize="20" />
                  </a>
                </div>
                <div>
                  <a
                    href={`mailto:${location && location.email}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <AiOutlineMail color={data.color} fontSize="24" />
                  </a>
                </div>
                <div>
                  <a
                    href={`tel:${location && location.phone}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <ImPhone color={data.color} fontSize="20" />
                  </a>
                </div>
              </div>
              {isLoggedIn && (
                <div
                  className="header-user-inner"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    paddingRight: 10,
                    fontSize: 13,
                    cursor: "pointer",
                  }}
                >
                  <a onClick={this.logout} style={{ color: "#000" }}>
                    выход из системы
                  </a>
                </div>
              )}
              {!isLoggedIn && (
                <div
                  className="header-user-inner"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    paddingRight: 10,
                    fontSize: 13,
                  }}
                >
                  <a
                    href={`/${this.store.page.lang}/account`}
                    onClick={this.store.logout}
                    style={{ color: "#000" }}
                  >
                    Account
                  </a>
                </div>
              )}
            </React.Fragment>
          )}
        </div>

        {data.steps?.length > 1 && appConfig.locale.showPrice && (
          <MobileTitle store={this.store} />
        )}
      </>
    );
  }
}

export default withRouter(Header);
